import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { settingsRoute } from './routes';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: settingsRoute,
        meta: {
            plusPaymentPage: 'Settings',
            page: 'settings',
        },
        component: lazy(() => import('./components/Settings/Settings')),
        fallback: RouteSkeleton,
    });
});

export * from './routes';

export default scenario;
